<template>
    <b-card-code
            title="Új hozzáadása"
    >
        <b-overlay
                :show="loading"
                spinner-variant="primary"
                spinner-type="grow"
                rounded="sm"
        >
            <!-- form -->
            <validation-observer ref="simpleRules">
                <b-form>
                    <b-row>

                        <b-col md="4">
                            <b-form-group
                                    label="Halkategória"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="halkategória"
                                        rules="required"
                                        vid="fishCategory"
                                >
                                    <v-select
                                            v-model="formData.fishCategory"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            label="title"
                                            :options="fishCategoryOptions"
                                    >
                                        <template #no-options>
                                            <span style="">Sajnáljuk, nincs egyező találat.</span>
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group
                                    label="Név"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="név"
                                        rules="required"
                                        vid="name"
                                >
                                    <b-form-input
                                            v-model="formData.name"
                                            :state="errors.length > 0 ? false:null"
                                            placeholder="név"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group
                                    label="Szín"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="szín"
                                        rules="required"
                                        vid="color"
                                >
                                    <b-form-input
                                            type="color"
                                            v-model="formData.color"
                                            :state="errors.length > 0 ? false:null"
                                            placeholder="szín"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group
                                    label="Minimum tömeg"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="minimum tömeg"
                                        rules=""
                                        vid="minWeight"
                                >
                                    <b-input-group>
                                        <b-form-input
                                                v-model="formData.minWeight"
                                                type="number"
                                                lang="hu"
                                                :state="errors.length > 0 ? false:null"
                                                :step="0.01"
                                                :min="0"
                                        />
                                        <b-input-group-append>
                                            <b-input-group-text>kg</b-input-group-text>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group
                                    label="Maximum tömeg"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="maximum tömeg"
                                        rules=""
                                        vid="maxWeight"
                                >
                                    <b-input-group>
                                        <b-form-input
                                                v-model="formData.maxWeight"
                                                type="number"
                                                lang="hu"
                                                :state="errors.length > 0 ? false:null"
                                                :step="0.01"
                                                :min="0"
                                        />
                                        <b-input-group-append>
                                            <b-input-group-text>kg</b-input-group-text>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group
                                    label="Minimum hossz"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="minimum hossz"
                                        rules=""
                                        vid="minLength"
                                >
                                    <b-input-group>
                                        <b-form-input
                                                v-model="formData.minLength"
                                                type="number"
                                                lang="hu"
                                                :state="errors.length > 0 ? false:null"
                                                :min="0"
                                        />
                                        <b-input-group-append>
                                            <b-input-group-text>cm</b-input-group-text>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group
                                    label="Maximum hossz"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="maximum hossz"
                                        rules=""
                                        vid="maxLength"
                                >
                                    <b-input-group>
                                        <b-form-input
                                                v-model="formData.maxLength"
                                                type="number"
                                                lang="hu"
                                                :state="errors.length > 0 ? false:null"
                                                :min="0"
                                        />
                                        <b-input-group-append>
                                            <b-input-group-text>cm</b-input-group-text>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group
                                    label="Minimum kerület"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="minimum kerület"
                                        rules=""
                                        vid="minPerimeter"
                                >
                                    <b-input-group>
                                        <b-form-input
                                                v-model="formData.minPerimeter"
                                                type="number"
                                                lang="hu"
                                                :state="errors.length > 0 ? false:null"
                                                :min="0"
                                        />
                                        <b-input-group-append>
                                            <b-input-group-text>cm</b-input-group-text>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group
                                    label="Maximum kerület"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="maximum kerület"
                                        rules=""
                                        vid="maxPerimeter"
                                >
                                    <b-input-group>
                                        <b-form-input
                                                v-model="formData.maxPerimeter"
                                                type="number"
                                                lang="hu"
                                                :state="errors.length > 0 ? false:null"
                                                :min="0"
                                        />
                                        <b-input-group-append>
                                            <b-input-group-text>cm</b-input-group-text>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <!-- submit button -->
                        <b-col class="mt-1">
                            <b-button
                                    variant="primary"
                                    type="submit"
                                    class="float-right"
                                    @click.prevent="submitForm"
                            >
                                Mentés
                            </b-button>
                            <cancel-and-g-o-t-o-previous-page class="mr-2"/>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </b-overlay>
    </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormCheckbox,
    BOverlay,
    BInputGroupText,
    BInputGroupAppend,
    BInputGroup,
} from 'bootstrap-vue'
import {
    required,
} from '@validations'
import vSelect from 'vue-select'
import cancelAndGOTOPreviousPage from '@/views/pages/_components/_helper/cancelAndGOTOPreviousPage'

export default {
    components: {
        BInputGroup, BInputGroupAppend, BInputGroupText,
        BCardCode,
        ValidationProvider,
        ValidationObserver,
        BFormInput,
        BFormGroup,
        BForm,
        BRow,
        BCol,
        BButton,
        BFormCheckbox,
        BOverlay,
        vSelect,
        cancelAndGOTOPreviousPage,
    },
    data() {
        return {
            role: 'fish_type',
            loading: false,
            formData: {
                name: '',
                color: '#000000',
                fishCategory: '',
                minWeight: '',
                maxWeight: '',
                minLength: '',
                maxLength: '',
                minPerimeter: '',
                maxPerimeter: '',
            },
            fishCategoryOptions: [],
            required,
        }
    },
    created() {
        this.loading = true

        this.$store.dispatch('fetchFishCategoriesForSelect').then(response => {
            this.fishCategoryOptions = response

            if (this.fishCategoryOptions.length) {
                this.formData.fishCategory = this.fishCategoryOptions[0]
            }
        }).finally(() => {
            this.loading = false
        })
    },
    methods: {
        submitForm() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.loading = true

                    // clone formData
                    let fd = JSON.parse(JSON.stringify(this.formData))
                    fd.fishCategory = this.formData.fishCategory.value
                    this.$store.dispatch('storeFishType', fd).then(() => {
                        this.$helpers.showSuccessToast('Új halfaj létrehozva.')

                        this.$acl.canListPermission(this.role)
                            ? this.$router.push({name: 'fish-types'})
                            : this.$router.go(-1)
                    }).catch(error => {
                        if (error.response.status === 422) {
                            this.$refs.simpleRules.setErrors(error.response.data.errors)
                        } else {
                            this.$helpers.showErrorToast(error.toString())
                        }
                    }).finally(() => {
                        this.loading = false
                    })
                }
            })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
